import { Button } from "@/components/buttons";
import { useAuth0 } from "@auth0/auth0-react";
import ErrorPage from "./ErrorPage";
import { useTranslation } from "react-i18next";

const Oops = () => {
  const { logout } = useAuth0();
  const { t } = useTranslation();

  return (
    <ErrorPage title={t("error.errorOccured")}>
      <div tw="py-2">
        <Button
          red
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
          tw="w-fit"
        >
          {t("action.logOut")}
        </Button>
      </div>
    </ErrorPage>
  );
};

export default Oops;
